var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralSentimentInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "65 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sentiments"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5_2",
    cx: 94,
    cy: 29,
    r: 28.5,
    fill: "#363A48",
    stroke: "#363A48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M81 27C81.1667 27 82 27 83 27.5C83.8944 27.9472 84 31 86 31C88 31 88.5 27.5 91.5 27.5C94.5 27.5 95 31 97 31C99 31 99 27.5 102 27.5C105 27.5 104.5 31 108 31",
    stroke: "#FBBF5D",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralSentimentInactive);
export default __webpack_public_path__ + "static/media/NeutralSentimentInactive.702f78f29024f4b9d53b558f7c332d04.svg";
export { ForwardRef as ReactComponent };